/**
 * PageTabs - Unboxed tab strip (no Paper panel)
 */

import React from "react";
import { Box, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";

const TabsRoot = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  [theme.breakpoints.up("md")]: {
    marginBottom: theme.spacing(3),
  },
}));

/**
 * Drop-in for MUI Tabs without a surrounding Paper.
 * Pass the same props you would pass to <Tabs />.
 */
const PageTabs = ({ children, ...tabsProps }) => (
  <TabsRoot data-testid="page-tabs">
    <Tabs
      variant={tabsProps.variant || "scrollable"}
      scrollButtons={tabsProps.scrollButtons ?? "auto"}
      {...tabsProps}
    >
      {children}
    </Tabs>
  </TabsRoot>
);

export default PageTabs;
